import Vue from "vue";
import Vuex, { ActionContext } from "vuex";
import { UserLoggedInfoModel } from "../models/userModels";
import eventHub from "../eventHub";
import api from "@/services/api";
import VuexPersistence from "vuex-persist";

Vue.use(Vuex);

var VERSION = "0.0.0.1";

class brkpoints {
	xs: number;
	sm: number;
	md: number;
	lg: number;
	xl: number;
}

// copied
// $grid-breakpoints: (
//   xs: 0,
//   sm: 576px,
//   md: 768px,
//   lg: 992px,
//   xl: 1200px
// ) !default;
const bootstrap_4_5_Breakpoints = {
	xs: 0,
	sm: 576,
	md: 768,
	lg: 992,
	xl: 1200
};
const brkp: brkpoints = bootstrap_4_5_Breakpoints;

class Store {
	constructor() {
		this.user = null;
		this.appCulture = "it-IT";
		// this.appCulture = localStorage.getItem("app-culutre")
		//   ?  localStorage.getItem("app-culutre")
		//   : "it-IT";
		this.version = VERSION;
		this.width = 0;
		this.height = 0;
		this.requestCount = 0;
		this.connectionSelected = null;
	}
	public user: UserLoggedInfoModel | null;
	public appCulture: string;
	public width: number;
	public height: number;
	public version: string;
	public requestCount: number | null;
	public connectionSelected: string | null;
}

const vuexLocal = new VuexPersistence({
	storage: window.sessionStorage
});

export default new Vuex.Store<any>({
	state: new Store(),
	getters: {
		getConnectionSelected: state => {
			return state.connectionSelected;
		},
		getRequestCount: state => {
			return state.requestCount;
		},
		getIsAnyRequestPanding: state => {
			return state.requestCount > 0;
		},
		getAppCulture: state => {
			return state.appCulture;
		},
		getUser: state => {
			return state.user;
		},
		getIsAuthenticated: state => {
			return state.user != null;
		},
		getUserFirstName: state => {
			return state.user != null ? state.user.firstName : "";
		},
		getUserId: state => {
			return state.user != null ? state.user.id : null;
		},
		getUserLastName: state => {
			return state.user != null &&
				state.user.lastName != state.user.firstName
				? state.user.lastName
				: "";
		},
		getUserRole: state => {
			if (state.user == null || state.user.roles == null) return "";
			return state.user.roles[0];
		},
		xs: state => {
			return true;
		},
		xsOnly: state => {
			return state.width < brkp.sm;
		},
		xsAndUp: state => {
			return true;
		},
		xsAndDown: state => {
			return state.width < brkp.sm;
		},
		sm: state => {
			return state.width >= brkp.sm;
		},
		smOnly: state => {
			return state.width >= brkp.sm && state.width < brkp.md;
		},
		smAndUp: state => {
			return state.width >= brkp.sm;
		},
		smAndDown: state => {
			return state.width < brkp.md;
		},
		md: state => {
			return state.width >= brkp.md;
		},
		mdOnly: state => {
			return state.width >= brkp.md && state.width < brkp.lg;
		},
		mdAndUp: state => {
			return state.width >= brkp.md;
		},
		mdAndDown: state => {
			return state.width < brkp.lg;
		},
		lg: state => {
			return state.width >= brkp.lg;
		},
		lgOnly: state => {
			return state.width >= brkp.lg && state.width < brkp.xl;
		},
		lgAndUp: state => {
			return state.width >= brkp.lg;
		},
		lgAndDown: state => {
			return state.width < brkp.xl;
		},
		xl: state => {
			return state.width >= brkp.xl;
		},
		xlOnly: state => {
			return state.width >= brkp.xl;
		},
		xlAndUp: state => {
			return state.width >= brkp.xl;
		},
		xlAndDown: state => {
			return true;
		},
		isSmallScreen: (state, getters) => {
			return getters.mdAndDown;
		}
	},
	mutations: {
		initialiseStore(state) {
			// Check if the store exists
			// if (localStorage.getItem("store")) {
			// 	let store = JSON.parse(localStorage.getItem("store"));
			if (sessionStorage.getItem("store")) {
				let store = JSON.parse(sessionStorage.getItem("store"));

				// Check the version stored against current. If different, don't
				// load the cached version
				if (store.version == VERSION) {
					this.replaceState(Object.assign(state, store));
				} else {
					state.version = VERSION;
				}
			}
		},
		setWindowSize(state, size: any) {
			state.width = window.innerWidth;
			state.height = window.innerHeight;
		},
		setConnectionSelected(state, connectionSelected: string) {
			state.connectionSelected = connectionSelected;
		},
		setRequestCountIncrease(state) {
			state.requestCount++;
		},
		setRequestCountDecrease(state) {
			state.requestCount--;
		},
		setUser(state, userInfo: UserLoggedInfoModel) {
			state.user = userInfo;
		}
	},
	actions: {
		loginUser(context, token) {
			localStorage.setItem("staging-management-token", token);
			eventHub.$emit(eventHub.events.USER_LOGIN);
			return context.dispatch("updateUserInfo");
		},
		logoutUser(context) {
			return api
				.doLogout()
				.then(res => {
					//    localStorage.clear();
					localStorage.removeItem("staging-management-token");
					sessionStorage.clear();

					eventHub.$emit(eventHub.events.USER_LOGOUT);
					// localStorage.setItem("store", JSON.stringify(new Store()));
					// this.dispatch("initialiseStore");

					//this.replaceState(Object.assign(this.state, new Store()));

					// context.commit("setUser", null);
					// context.commit("setCurrentCustomer", null);
					return res;
				})
				.catch(error => {
					console.error(error);
				});
		},
		updateUserInfo(context) {
			return api
				.getUserInfo()
				.then(data => {
					context.commit("setUser", data);
					return data;
				})
				.catch(error => {
					console.error(error);
				});
		},
		setConnectionSelected(context, connectionSelected: string) {
			return new Promise<void>((resolve, reject) => {
				context.commit("setConnectionSelected", connectionSelected);
				resolve();
			});
		},
		increseRequestCount(context) {
			return new Promise<void>((resolve, reject) => {
				context.commit("setRequestCountIncrease");
				resolve();
			});
		},
		decreaseRequestCount(context) {
			return new Promise<void>((resolve, reject) => {
				context.commit("setRequestCountDecrease");
				resolve();
			});
		}
	},
	plugins: [vuexLocal.plugin]
});
